export default fetch => ({
  getList (
    conditions, // Name, CountryCode, IsMore
    loading // (isLoading: boolean) => void
  ) {
    return fetch({
      url: '/api/v1/customer/GetCustomerList',
      data: conditions,
      loading,
      headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
    })
  },

  getBaseInfo (Pkey, loading) {
    return fetch({
      url: '/api/v1/customer/GetCustomerBaseInfo',
      data: { Pkey },
      loading,
      headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
    })
  },

  getPropertyInfo (CustomerCode, loading) {
    return fetch({
      url: '/api/v1/customer/GetCustomerPropertyList',
      data: { CustomerCode },
      loading,
      headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
    })
  },

  getDistributorInfo (CustomerID, loading) {
    return fetch({
      url: '/api/v1/customer/GetCustomerDistributorInfo',
      data: { CustomerID },
      loading,
      headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
    })
  },
  getRegionAndOfficeByBU (CustomerID, BUCode, loading) {
    return fetch({
      url: '/api/v1/customer/GetRegionOfficeForBUWithSICustomer',
      data: { CustomerID, BUCode },
      loading,
      headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
    })
  },
  createProperty (data, loading) {
    // {
    //   "CustomerID": "string",
    //   "AccountRoleCode": "string",
    //   "RegionCode": "string",
    //   "BUCode": "string",
    //   "OfficeCode": "string",
    //   "CreateDate": "2021-07-04T12:27:45.843Z",
    //   "Creator": "string",
    //   "CreatorUserName": "string"
    // }
    return fetch({
      url: '/api/v1/customer/CustomerPropertyCreate',
      data,
      loading,
      headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
    })
  },
  getQCCInfo (Pkey, loading) {
    return fetch({
      url: '/api/v1/customer/GetQCCInfo',
      data: { Pkey },
      loading,
      headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
    })
  },
  createCustomer (data, loading) {
    return fetch({
      url: '/api/v1/customer/SimpleCustomerRequest',
      data,
      loading
      // headers: process.env.NODE_ENV === 'development' ? { Account: 'admin' } : {}
    })
  }
})
